export default __webpack_public_path__ + "static/typography-ga-metric-text-00bd9d01bcee310a063e6c81f7546237.png";